<template>
    <div class="foodMenuBox">
        <div class="food-main-box"  style="overflow:inherit"  v-if="orderMap_Type==2 ||orderMap_Type==1" :style="foodMainStyle">
            <categorys-page class="filter-nav panel" 
                :data="foodMainCategory" 
                :row="foodMainArg.row" 
                :col="foodMainArg.col" 
                :selectIndex="mainCategoryIndex"
                :bottomH="setBottomH"
                :pageIndex="foodMainPageIndex"
                navFirstName="全部大类"
                v-slot="{item}" @navClick="onFoodNav">
                {{item.MainCategory_Name}}
            </categorys-page>
        </div>
        <div class="food-sub-box"  style="overflow:inherit;margin-top:5px" v-if="orderMap_Type==3 ||orderMap_Type==1" :style="foodSubStyle">
            <categorys-page class="filter-nav panel" 
                :data="foodSubCategorys" 
                :row="foodSubArg.row" 
                :col="foodSubArg.col" 
                :selectIndex="subCategoryIndex"
                :bottomH="setBottomH"
                :pageIndex="foodSubPageIndex"
                navFirstName="全部小类"
                v-slot="{item}" @navClick="onFoodSubNav">
                {{item.SubCategory_Name}}
                <b v-show="subCategoryNumberKey[item.SubCategory_ID]>0">{{subCategoryNumberKey[item.SubCategory_ID]}}</b>
            </categorys-page>
        </div>
        <!-- 急推菜 -->
        <div class="panel menu menu-flex-box" :style="suggestStyle" v-if="isShowSuggest" >
            <div class="suggest-flex-box item-flex-box" >
                <layout-rc class="item-box clearfix" isVarCss :list="suggestPagesList" :row="suggestArg.row" :col="suggestArg.col" :marginW="2" :marginH="2">
                    <div class="item-li" :class="{selected:item.Food_ID==choicePosFoods}" v-for="item in suggestPagesList" :key="item" @click="parent.onPlaceFoods(item)">
                        <div class="title">
                            <i class="iconfont icon-tesecai" v-show="sysSetting.RunOrderListShowSpecialFoodFlag && item.Is_Special"></i>{{item.Food_Name}}
                        </div>
                        <b v-show="getFoodNumber(item)>0">{{getFoodNumber(item)}}</b>
                        <div class="bottom-box" v-if="item.Is_Limited && item.Is_LimitedProject">
                            <div class="text-left" v-if="item.Is_Promotion || (item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price)">剩: <span class="red">{{item.RemainNum}}</span></div>
                            <div class="bottom-flex-box">
                                <!-- 促销价 -->
                                <div class="cxPrice" v-if="item.Is_Promotion">
                                    <div class="cxTag">促</div>
                                    <div class="unit">￥</div>{{item.Promotion_Price}}
                                </div>
                                <!-- vip 价格 -->
                                <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                    <div class="vipTag">VIP</div>
                                    <div class="price"> 
                                        <div class="unit">￥</div>{{item.Food_VipPrice}}
                                    </div>
                                </div>
                                <div class="text-left" v-else>剩: <span class="red">{{item.RemainNum}}</span></div>
                                <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                            </div>
                        </div>
                        <div class="bottom-box bottom-flex-box" v-else>
                            <!-- 促销价 -->
                            <div class="cxPrice" v-if="item.Is_Promotion">
                                <div class="cxTag">促</div>
                                <div class="unit">￥</div>{{item.Promotion_Price}}
                            </div>
                            <!-- vip 价格 -->
                            <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                <div class="vipTag">VIP</div>
                                <div class="price"> 
                                    <div class="unit">￥</div>{{item.Food_VipPrice}}
                                </div>
                            </div>
                            <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                        </div>
                        <tag-sold-out v-if="item.Is_SoldOut && !item.MultipleSizeFoods?.some(it=>!it.Is_SoldOut)"></tag-sold-out>
                        <div class="tag tag-grey" v-if="!item.Is_SoldOut && item.Is_Limited && item.Is_LimitedProject && item.RemainNum==0">售罄</div>
                    </div>
                    <div class="page-box" v-if="suggestPagesCount>1">
                        <page-turning class="page-botton" v-model="suggestPageIndex" :pageCount="suggestPagesCount" type="up"><i class="iconfont icon-a-order-up"></i></page-turning>
                        <page-turning class="page-botton" v-model="suggestPageIndex" :pageCount="suggestPagesCount"><i class="iconfont icon-a-order-down"></i></page-turning>
                    </div>
                </layout-rc>
            </div>
        </div>
        <div class="panel menu menu-flex-box" :style="[menuStyle,{flex:foodRow,position:'relative'}]" ref="menuPanel">
            <sf-panel v-if="$global.SFAiStatus && Is_AIRegistered && !parent.isCheckOut"/>
            <div class="keyboard" v-if="$global.NumberkeyOff">
                <div class="key-li tr-li" >
                    <span @click="keyNumber(item)" v-for="(item) in [0,1,2,3,4,5,6,7,8,9,0.5,'.']" :key="item">
                        <p class="bubbing" v-show="orderNumber!=='' && !(orderNumber<0) && orderNumberType==item">{{orderNumber}}</p>
                        {{item}}
                    </span>
                    <span @click="keyNumber(-1)"><i class="iconfont icon-zuojiantou"></i></span>
                </div>
            </div>
            
            <!-- 菜单 -->
            <div class="item-flex-box" >
                <layout-rc class="item-box clearfix" :isVarCss="true" :row="foodRow" :col="arg.col" :marginW="2" :marginH="2" :list="foodsPages">
                    <div class="item-li" :class="{selected:item.Food_ID==choicePosFoods}" v-for="item in foodsPages" :key="item" @click="parent.onPlaceFoods(item)">
                        <div class="title">
                            <i class="iconfont icon-tesecai" v-show="sysSetting.RunOrderListShowSpecialFoodFlag && item.Is_Special"></i>{{item.Food_Name}}
                        </div>
                        <b v-show="getFoodNumber(item)>0">{{getFoodNumber(item)}}</b>
                        <div class="bottom-box" v-if="item.Is_Limited && item.Is_LimitedProject">
                            <div class="text-left" v-if="item.Is_Promotion || (item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price)">剩: <span class="red">{{item.RemainNum}}</span></div>
                            <div class="bottom-flex-box">
                                <!-- 区域售价 -->
                                <div class="cxPrice" v-if="item.Food_RoomPrice>0 && (!item.Is_Promotion || (item.Is_Promotion && item.Food_RoomPrice>item.Promotion_Price))">
                                    <div class="cxTag">包</div>
                                    <div class="unit">￥</div>{{item.Food_RoomPrice}}
                                </div>
                                <!-- 促销价 -->
                                <div class="cxPrice" v-else-if="item.Is_Promotion">
                                    <div class="cxTag">促</div>
                                    <div class="unit">￥</div>{{item.Promotion_Price}}
                                </div>
                                <!-- vip 价格 -->
                                <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                    <div class="vipTag">VIP</div>
                                    <div class="price"> 
                                        <div class="unit">￥</div>{{item.Food_VipPrice}}
                                    </div>
                                </div>
                                <div class="text-left" v-else>剩: <span class="red">{{item.RemainNum}}</span></div>
                                <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                            </div>
                        </div>
                        <div class="bottom-box bottom-flex-box" v-else>
                            <!-- 区域售价 -->
                            <div class="cxPrice" v-if="item.Food_RoomPrice>0 && (!item.Is_Promotion || (item.Is_Promotion && item.Food_RoomPrice>item.Promotion_Price))">
                                <div class="cxTag">包</div>
                                <div class="unit">￥</div>{{item.Food_RoomPrice}}
                            </div>
                            <!-- 促销价 -->
                            <div class="cxPrice" v-else-if="item.Is_Promotion">
                                <div class="cxTag">促</div>
                                <div class="unit">￥</div>{{item.Promotion_Price}}
                            </div>
                            <!-- vip 价格 -->
                            <div class="vipPrice" v-else-if="item.Food_VipPrice>0 && item.Food_VipPrice!=item.Food_Price">
                                <div class="vipTag">VIP</div>
                                <div class="price"> 
                                    <div class="unit">￥</div>{{item.Food_VipPrice}}
                                </div>
                            </div>
                            <div class="text-right">￥{{item.Food_Price}}/{{item.Food_Size}}</div>
                        </div>
                        <tag-sold-out v-if="item.Is_SoldOut && !item.MultipleSizeFoods?.some(it=>!it.Is_SoldOut)"></tag-sold-out>
                        <div class="tag tag-grey" v-if="!item.Is_SoldOut && item.Is_Limited && item.Is_LimitedProject && item.RemainNum==0">售罄</div>
                    </div>
                </layout-rc>
            </div>
            <div class="search-box">
                <key-board-input class="search"
                    type="text" v-model="varietySelect" ref="searchBox" placeholder="菜品模糊检索"
                    @keydown="keyCursor"
                    isBarcode @barcode="barcode"
                    :focusLock="true"
                    :keyOptions="{isKeyDownEnter:true}"
                ></key-board-input>
                <div class="bnt menuOrder-bnt" @click="menuOrder()" v-if="sysSetting?.Running_BestMenu_YN">
                    <img src="/images/menuBnt.png"/>
                </div>
                <div class="bnt shuaxin-bnt" @click="RefreshData()"><i class="iconfont icon-a-shuaxin3x"></i>刷新</div>
                <div class="page-box-bottom">
                    <span class="last-page iconfont icon-fangxiangquan-left" @click="pageIndex<=1?1:pageIndex--"></span>
                    <span class="page-number">{{ pageIndex }}/{{ pageCount }}页</span>
                    <span class="next-page iconfont icon-fangxiangquan-right" @click="pageIndex>=pageCount?pageCount:pageIndex++" ></span>
                </div>
            </div>
        </div>
        
        <div class="panel footer-flex-box" :style="footerStyle">
            <layout-rc class="btn-box" :isVarCss="true" :list="userBottomMenuPages" :row="footerArg.row" :col="footerArg.col" :marginW="2" :marginH="2">
                <div class="btn" :class="{btnKey:item.ProjectItem_Key=='goCheckOut',btnReturn:item.ProjectItem_Key=='OrderReturn'}" v-show="item.Is_Show==true" 
                    v-for="(item,ProjectItem_Index) in userBottomMenuPages" :key="ProjectItem_Index" 
                    @click="parent.BottomMenuClick(item)">
                    {{item.ProjectItem_Name}}
                    <span class="shortKey" v-if="item.ProjectItem_ShortcutKey">{{item.ProjectItem_ShortcutKey}}</span>
                </div>
                <div class="page-box" v-if="userBottomMenuPagesCount>1">
                    <page-turning class="page-botton" v-model="userBottomPageIndex" :pageCount="userBottomMenuPagesCount" type="up"><i class="iconfont icon-a-order-up"></i></page-turning>
                    <page-turning class="page-botton" v-model="userBottomPageIndex" :pageCount="userBottomMenuPagesCount"><i class="iconfont icon-a-order-down"></i></page-turning>
                </div>
            </layout-rc>
        </div>

        <floating-menu className="missedBnt defaultStyle" v-if="missedFoodList?.length>0" cacheName="missedFoodBnt" data-v-food :isKeyBoard="false" @click="isShowMissed=!isShowMissed">
            <div class="icon-box">
                <i class="iconfont" :class="isShowMissed?'icon-a-AIdiancai-kai':'icon-a-AIdiancai-guan'"></i>
            </div>
            <span>遗漏菜</span>
        </floating-menu>
    </div>
</template>

<script>
import {config} from '../../../../common'
//点餐 右边界面 菜品分类+菜品数据+底部按钮 
export default {
    name:"foodMenuBox",
    data(){
        let arg={row:6,col:6,marginW:'6',marginH:'6'}
        let globalSysSetting= this.$cacheData?.globalVariable?.GlobalSysSetting;
        if(globalSysSetting){
            arg={row:globalSysSetting.OrderMap_X,col:globalSysSetting.OrderMap_Y,marginW:'6',marginH:'6'};
        }
        return {
            //餐厅id
            Eat_RoomID:"",
            //大类 行列数
            foodMainArg:{row:2,col:8},
            //大类 样式
            foodMainStyle:{},
            //小类 行列数
            foodSubArg:{row:2,col:8},
            //小类 样式
            foodSubStyle:{},
            //菜品 行列 数  
            arg:arg,    
            //横排底部按钮样式 样式
            footerStyle:{},
            //横排底部按钮样式 行列数
            footerArg:{row:1,col:8},
            //点菜 数字键位置 样式
            menuStyle:{},
            //点菜界面横排自定义按钮 当前页码 
            userBottomPageIndex:1,
            //餐厅关联的菜品类别
            EatRooms:[],
            //餐厅关联的菜品 定价
            RoomPrice:[],
            //大类分页 当前页码 
            foodMainPageIndex:1,
            mainCategoryIndex:0,
            //小类分页 当前页码 
            foodSubPageIndex:1,
            subCategoryIndex:0,
            /**菜品页码 分页用 */
            pageIndex:1,
            /**菜品检索框 输入的内容 */
            varietySelect:'',
            //记录上一次检索 不记录则按菜品检索
            oldVarietySelect:"",
            //菜品检索用
            menuTxt:"",
            /**选择的菜品 */
            choicePosFoods:0,
            //点菜数量 标签 点击的是那个数 0-9 .
            orderNumberType:-1,
            /**推荐菜页码 */
            suggestPageIndex:1,
            //该设备是否注册了AI识别点餐功能
            Is_AIRegistered:false,
            //遗漏的菜
            missedFoodList:[],
            //是否只显示遗漏的菜
            isShowMissed:false
        }
    },
    computed:{
        //父级
        parent(){
            return this.$parent;
        },
        //桌台是否锁定
        DeskLocked(){
            return this.parent.DeskLocked;
        },
        //锁定后 可操作的 uuid
        lockEqId(){
            return this.parent.lockEqId;
        },
        //桌台数据
        posDesks(){
            return this.parent.posDesks;
        },
        //系统参数配置
        sysSetting(){
            return this.$cacheData?.globalVariable?.GlobalSysSetting;
        },
        /**点菜界面类别显示方式 1：大类+小类，2：大类，3：小类 */
        orderMap_Type(){
            return this.sysSetting.OrderMap_Type||1;
        },
        //数量
        orderNumber(){
            return this.parent.orderNumber;//
        },
        //所以菜品数据
        getPosFoodData(){
            return this.parent.getPosFoodData;
        },
        //餐厅关联的菜品类别
        linkFoodKinds(){
            return this.EatRooms?.find(it=>it.Room_AutoID==this.parent?.orderInfo?.Eat_RoomID)?.Room_LinkFoodKinds||[];//餐厅关联的菜品类别
        },
        /**区域 定价 */
        roomFoods(){
            let roomInfo=this.RoomPrice?.find(it=>it.Room_ID==this.parent?.orderInfo?.Eat_RoomID);
            if(this.parent?.orderInfo?.Eat_DeskID && roomInfo && !(roomInfo.Reject_DeslIds?.indexOf(this.parent?.orderInfo?.Eat_DeskID)>=0)){//餐厅下排除的桌台ID, 被排除的桌台不执行区域价
                
                return roomInfo.RoomFoods||[];//区域定价菜品信息
            }
            return [];
        },
        //大类
        foodMainCategory(){
            let mainCategory=[];
            if(this.linkFoodKinds?.length>0){
                this.getPosFoodData?.forEach(it=>{
                    let FoodSubCategorys=it.FoodSubCategorys?.filter(sub=>this.linkFoodKinds.indexOf(sub.SubCategory_ID)>=0)//过滤小类
                    if(FoodSubCategorys?.length>0){
                        mainCategory.push(Object.assign({},it,{FoodSubCategorys:FoodSubCategorys}));
                    }
                })
            }else{
                mainCategory=this.getPosFoodData?.filter(it=>{
                    if(it.Is_ForwardMainCategory){//推荐菜
                        return it.FoodSubCategorys.some(sub=>!sub.isStop);//是否有 没停售的分类
                    }
                    return true;
                });
            }
            mainCategory.forEach(main=>{
                main.FoodSubCategorys?.forEach(sub=>{
                    sub.PosFoods?.forEach(it=>{
                        let item=this.roomFoods?.find(item=>item.Food_ID==it.Food_ID);//有区域菜品定价
                        it.Food_RoomPrice=0;
                        if(item){//
                            it.Food_RoomPrice=item.Food_RoomPrice;//区域售价
                        }else{
                            it.Food_RoomPrice=0;
                        }
                        
                        if(it.MultipleSizeFoods?.length>0){//多单位
                            it.MultipleSizeFoods.forEach(multiple=>{
                                let itemSize=this.roomFoods?.find(item=>item.Food_ID==multiple.Food_ID);//有区域菜品定价
                                if(itemSize){
                                    multiple.Food_RoomPrice=itemSize.Food_RoomPrice;//区域售价
                                }else{
                                    multiple.Food_RoomPrice=0;
                                }
                            })
                        }
                    })
                })
            })
            return mainCategory;
        },
        //全部小类
        allSubCategorys(){
            let all=[];
            this.foodMainCategory?.forEach(it=>{
                all=all.concat(it.FoodSubCategorys);
            });
            return all;
        },
        //小类
        foodSubCategorys(){
            let foodSubCategorys=this.allSubCategorys;
            if(this.mainCategoryIndex>0){//大类分类 第几
                foodSubCategorys=this.foodMainCategory[this.mainCategoryIndex-1].FoodSubCategorys;
            }
            return foodSubCategorys.filter(it=>!it.isStop);//排除暂停售卖的
        },
        /**全部菜品 过滤推荐菜分类*/
        allFoods(){
            let list=[];
            this.allSubCategorys?.filter(it=>!it.Is_ForwardSubCategory)?.forEach(it=>{
                list=list.concat(it.PosFoods);
            })
            return list;
        },
        /**全部推荐菜 */
        allForwardSub(){
            return this.allSubCategorys?.filter(it=>it.Is_ForwardSubCategory);
        },
        /**菜品分页显示 */
        foodsPages(){
            return this.posFoodsFilter?.slice((this.pageIndex-1)*this.pageSize,this.pageIndex*this.pageSize);
        },
        /**菜品 行数 */
        foodRow(){
            if(this.isShowSuggest){//有急推菜
                return this.arg.row-this.suggestArg.row;
            }
            return this.arg.row;
        },
        //一页多少条
        pageSize(){
            let size=this.foodRow*this.arg.col;
            return size;
        },
        //总条数
        pageCount(){
            return Math.ceil(this.posFoodsFilter.length/this.pageSize);
        },
        //分类 下菜品
        posFoods(){
            let list=[];
            if(this.subCategoryIndex>0){//分类 下菜品
                list=this.foodSubCategorys[this.subCategoryIndex-1].PosFoods;
            }else{//全部分类 下菜品  过滤推荐菜分类
                this.foodSubCategorys?.filter(it=>!it.Is_ForwardSubCategory).forEach(it=>{
                    list=list.concat(it.PosFoods);
                })
            }
            return list;
        },
        //筛选出 遗漏的菜
        missedPosFoodFilter(){
            const list=[];
            if(this.missedFoodList.length>0){
                this.allFoods.forEach(it=>{
                    if(this.missedFoodList.some(food=>food.EAT_XFBMID==it.Food_ID)){
                        list.push(it);
                    }else  if(it.MultipleSizeFoods?.length>0){//多单位
                        it.MultipleSizeFoods.forEach(multiple=>{
                            if(this.missedFoodList.some(food=>food.EAT_XFBMID==multiple.Food_ID)){
                                list.push(multiple);
                            }
                        })
                    }
                })
            }
            return list;
        },
        //筛选 当前 菜品数据
        posFoodsFilter(){
            let list=[];
            //只显示 遗漏的菜
            if(this.isShowMissed && this.missedFoodList.length>0){
                list=this.missedPosFoodFilter;
            }else{
                //排除 不允许单点
                list=this.posFoods.filter(it=>!it.Is_OnlySendInSetmeal);
            }

            let menuTxt=this.menuTxt?.toLowerCase();
            if(menuTxt){
                list=list.filter(it=>(it.Food_Name||"").toLowerCase().indexOf(menuTxt)>=0 ||
                                     (it.Food_PinYin||"").toLowerCase().indexOf(menuTxt)>=0 || 
                                     (it.Food_Code||"").toLowerCase().indexOf(menuTxt)>=0
                                );
            }
            return list;
        },
        //点单底部按钮 数据
        userBottomMenu(){
            return this.parent.userBottomMenu;
        },
        /**点单底部按钮 分页显示 */
        userBottomMenuPages(){
            let size=this.footerArg.row*this.footerArg.col;
            if(this.userBottomMenuPagesCount>1){
                size=size-1;
            }
            return this.userBottomMenu?.slice((this.userBottomPageIndex-1)*size,this.userBottomPageIndex*size);
        },
        /**点单底部按钮 总页数 */
        userBottomMenuPagesCount(){
            let size=this.footerArg.row*this.footerArg.col;
            let num=1;
            if(this.userBottomMenu?.length>size){
                size=size-1;
                num=Math.ceil(this.userBottomMenu.length/size);
            }
            return num;
        },
        orderMenuList(){
            return this.parent.orderMenuList
        },
        /**点单菜品的数量  切非加价做法 */
        foodNumberKey(){
            let data={};
            this.orderMenuList?.filter(it=>!it.is_taste && it.Food_Type!=4).forEach(it=>{
                if(data[it.EAT_XFBMID]){
                    data[it.EAT_XFBMID]=Number(data[it.EAT_XFBMID]).compute(it.Eat_Number);
                }else{
                    data[it.EAT_XFBMID]=Number(it.Eat_Number);
                }
                it.Eat_TcItemList?.forEach(item=>{
                    if(data[item.EAT_XFBMID]){
                        data[item.EAT_XFBMID]=Number(data[item.EAT_XFBMID]).compute(item.Eat_Number);
                    }else{
                        data[item.EAT_XFBMID]=Number(item.Eat_Number);
                    }
                })
                it.FoodSetmeals?.forEach(item=>{
                    if(data[item.FoodSetmeal_ID]){
                        data[item.FoodSetmeal_ID]=Number(data[item.FoodSetmeal_ID]).compute(item.FoodSetmeal_Number); 
                    }else{
                        data[item.FoodSetmeal_ID]=Number(item.FoodSetmeal_Number);
                    }
                })
            })
            return data;
        },
        /**小类下 点单菜品的数量  */
        subCategoryNumberKey(){
            let subCategory={};
            this.foodSubCategorys?.forEach(it=>{
                let number=0;
                it.PosFoods?.forEach(item=>{
                    if(this.foodNumberKey[item.Food_ID]>0){
                        number+=this.foodNumberKey[item.Food_ID];
                    }

                    item.MultipleSizeFoods?.forEach(it=>{
                        if(this.foodNumberKey[it.Food_ID]>0){
                            number+=this.foodNumberKey[it.Food_ID];
                        }
                    })
                })
                if(number>0){
                    number=Number(number.toFixed(2));
                    subCategory[it.SubCategory_ID]=number;
                }
            })
            return subCategory;
        },
        suggestList(){
            let list=[];
            if(this.$global.EmergencyFoodIds?.length>0 && this.allFoods?.length>0){
                this.$global.EmergencyFoodIds.forEach(Food_ID=>{
                    let item=this.allFoods.find(it=>it.Food_ID==Food_ID);
                    if(item){
                        list.push(item);
                    }
                })
            }
            return list;
        },
        /**急推菜 过滤 沽清或售罄 数据 */
        suggestFilert(){
            //排除 不允许单点
            return this.suggestList?.filter(it=>!it.Is_SoldOut && !(!it.Is_SoldOut && it.Is_Limited && it.Is_LimitedProject && it.RemainNum==0) && !it.Is_OnlySendInSetmeal);
        },
        /**急推菜样式 */
        suggestStyle(){
            let style=Object.assign({},this.menuStyle,{height:'auto',flex:this.suggestArg.row});
            if(this.sysSetting?.EverydayEmergencyDishFoodBackgroundColor){
                style['--bgColor']=this.sysSetting?.EverydayEmergencyDishFoodBackgroundColor;
            }
            return style;
        },
        suggestArg(){
            let arg={row:0,col:this.arg.col};
            //启用【启用每日急推菜功能】 以及 每日急推菜占点单界面菜品行数 大于0
            if(this.sysSetting?.RunEverydayEmergencyDish && this.sysSetting?.EverydayEmergencyDishFoodRows>0){
                arg.row=this.sysSetting?.EverydayEmergencyDishFoodRows;
            }
            return arg;
        },
        /**一页多少条 */
        suggestSize(){
            let size=this.suggestArg.row*this.suggestArg.col;
            return size;
        },
        /**是否显示急推菜 */
        isShowSuggest(){
            /**急推菜有行数 有数据 */
            if(this.suggestArg.row>0 && this.suggestFilert?.length>0){
                return true;
            }
            return false;
        },
        /**急推菜 总页数 */
        suggestPagesCount(){
            let size=this.suggestSize;
            let num=1;
            if(this.suggestFilert?.length>size){
                size=size-1;
                num=Math.ceil(this.suggestFilert.length/size);
            }
            return num;
        },
        /**每日急推菜 数据 */
        suggestPagesList(){
            let size=this.suggestSize;
            if(this.suggestPagesCount>1){
                size=size-1;
            }
            return this.suggestFilert?.slice((this.suggestPageIndex-1)*size,this.suggestPageIndex*size);
        }
    },
    watch:{
        /**菜品搜索 */
        varietySelect(newVal,oldVal){
            console.log(newVal,oldVal);
            if(newVal && (newVal.indexOf('+')>=0 || newVal.indexOf('-')>=0 )){
                this.$nextTick(()=>{
                    this.varietySelect=oldVal;
                })
                return;
            }
            let menuTxt=this.varietySelect.toLowerCase();
            if(menuTxt=="" && this.oldVarietySelect){
                menuTxt=this.oldVarietySelect.toLowerCase();
            }else{
                this.oldVarietySelect="";
            }
            this.menuTxt=menuTxt;
            if(menuTxt){
                this.mainCategoryIndex=0;
                this.subCategoryIndex=0;
                if(this.foodsPages?.length>0){
                    this.choicePosFoods=this.foodsPages[0].Food_ID;
                }
            }
            
        },
        "sysSetting.DisplayingConfigs":{//桌台和点单界面显示设置
            handler(newVal){
                newVal?.forEach((it)=>{
                    let style={};
                    if(it.ScreenPx>0){
                        style["height"]=it.ScreenPx+"%";
                    }
                    if(it.Button_Color){
                        style["--bgColor"]=it.Button_Color;
                    }
                    if(it.Font_Name){
                        style["--fontFamily"]=it.Font_Name;
                    }
                    if(it.Font_Size){
                        style["--fontSize"]=it.Font_Size+"px"
                    }
                    if(it.Font_Color){
                        style["--fontColor"]=it.Font_Color
                    }
                    let arg={row:it.IntRow,col:it.IntCol};
                    if(it.Config_Kind==11){//菜品大类显示类型
                        this.foodMainArg=arg;
                        this.foodMainStyle=style;
                    }else if(it.Config_Kind==12){//为菜品小类显示类型   
                        this.foodSubArg=arg;
                        this.foodSubStyle=style;
                    }else if(it.Config_Kind==13){//为菜品显示类型   
                        this.arg={row:it.IntRow,col:it.IntCol,marginW:'6',marginH:'6'};
                        this.menuStyle=style;
                    }else if(it.Config_Kind==14){//为功能键显示类型   
                        this.footerArg=arg;
                        this.footerStyle=style;
                    }
                })
            },
            immediate:true
        },
        orderNumber(newVal){
            if(newVal==""){//清空数量 标签隐藏
                this.orderNumberType=-1
            }
        },
        /**当前时间变化了 */
        "$global.currentTime"(){
            this.forwardOperate();
        },
        allForwardSub(newVal,oldVal){
            if(oldVal==null || newVal?.length==oldVal?.length && !oldVal.some(old=>!newVal.some(it=>it.SubCategory_ID==old.SubCategory_ID))){//推荐菜没有发生变化 或 第一次加载菜品成功后 不提示
                this.forwardOperate(true);
            }else{
                this.forwardOperate();
            }
        },
        pageCount(){
            if(this.pageCount<this.pageIndex){
                this.pageIndex=1;
            }
        },
        //大分类修改时
        mainCategoryIndex(){
            if(this.mainCategoryIndex>0 || this.subCategoryIndex>0){//点其它分类 隐藏遗漏
                this.isShowMissed=false;
            }
        },
        //小分类修改时
        subCategoryIndex(){
            if(this.mainCategoryIndex>0 || this.subCategoryIndex>0){
                this.isShowMissed=false;
            }
        }
    },
    mounted(){
        //桌台 餐厅id
        this.Eat_RoomID=this.$route.params.Eat_RoomID;
        this.$nextTick(()=>{
            this.searchBoxFocus();
        })
        //区域定价
        this.$cacheData.RoomPrice().then(d=>{
            this.RoomPrice=d;
        }).catch((e)=>{
            console.log('加载餐厅区域定价失败：'+e);
        })
        //餐厅区域数据
        this.$cacheData.EatRooms().then((d)=>{
            this.EatRooms=d;
        }).catch((e)=>{
            console.log('加载餐厅区域数据失败：'+e);
        })
        this.forwardOperate();
        this.Is_AIRegistered=this.$auth.getUserInfo(); //获取用户id
        
    },
    methods:{
        /**推荐菜 时段 判断
         * @param isNoTip 是否不提示变化了
         */
        forwardOperate(isNoTip){
            if(this.allForwardSub?.length>0){//推荐菜分类
                let date=new Date();//当前时间
                let hourMinute=date.Format("hh:mm");//时分
                let weekDay=([7,1,2,3,4,5,6])[date.getDay()];//周

                let time=new Date(date.Format("yyyy-MM-ddT00:00:00"));//日期
                let outMes=[],newMes=[];
                this.allForwardSub.forEach(item=>{
                    let isBo=true;
                    if(item.Is_ControlSellDate){//是否控制该类别的售卖日期
                        if(time>=new Date(item.Begin_Date) && time<=new Date(item.End_Date)){//比较日期 还在范围内
                            isBo=true;
                        }else{
                            isBo=false;
                        }
                    }
                    if(isBo && item.WeekDays && !/(?=.*[1])(?=.*[2])(?=.*[3])(?=.*[4])(?=.*[5])(?=.*[6])(?=.*[7])/.test(item.WeekDays)){//是否控制该类别的售卖星期
                        if(item.WeekDays.indexOf(weekDay)>=0){//在星期 内
                            isBo=true;
                        }else{
                            isBo=false;
                        }
                    }
                    if(isBo && item.MenuSellTimes?.length>0){//菜单售卖时间段，如果该字段为空，则不限制时段
                        isBo=item.MenuSellTimes.some(it=>{
                            if(it.Start_Time<=it.End_Time){//结束时段 大于开始时段
                                if(hourMinute<it.Start_Time || hourMinute>it.End_Time){//当前时间 不在指定范围内 
                                    return false
                                }
                            }else{
                                if(hourMinute>it.End_Time && hourMinute<it.Start_Time){//当前时间 不在指定范围内 
                                    return false
                                }
                            }
                            return true;
                        })
                    }

                    if(item.isStop && isBo){//暂停售卖 后 开启售卖
                        item.isStop=false;
                        newMes.push(item.SubCategory_Name);
                    }else if(!item.isStop && !isBo){//开始售卖后 结束售卖了
                        item.isStop=true;
                        outMes.push(item.SubCategory_Name);
                    }
                })

                
                if(!isNoTip && (newMes.length>0 || outMes.length>0)){//上一次提示没有关闭时不用在弹出新的提示
                    //订单数据加载中不提示
                    if(this.parent.orderInfo?.Eat_AutoID && !this.isMessage){
                        this.isMessage=true;
                        this.$alert("推荐菜发生变化", '提示', {
                            dangerouslyUseHTMLString:true,
                            confirmButtonText: '知道了',
                            callback: () => {
                                this.isMessage=false;
                            }
                        })
                    }
                    this.mainCategoryIndex=0;
                    this.subCategoryIndex=0;
                    if(this.foodsPages?.length>0){
                        this.choicePosFoods=this.foodsPages[0].Food_ID;
                    }
                }
            }
        },
        //检索框 获取焦点
        searchBoxFocus(){
            this.$refs.searchBox.focus();
        },
        //显示 检索框 键盘
        showKeyBoard(){
            this.$refs.searchBox.focus();
            //判断键盘 未标记前是否是显示的
            if(this.$refs.searchBox?.oldIsShow){
                this.$refs.searchBox?.showKeyBoard();//显示键盘
            }
        },
        //关闭 检索框 键盘
        closeKeyBoard(){
            this.$refs.searchBox?.close(true);//关闭键盘并标记
        },
        // 选择菜品时记录 上次选中的菜品
        setOldvarietySelect(){
            if(this.varietySelect) {
                this.oldVarietySelect=this.varietySelect;
            }
            this.varietySelect='';
        },
        //计算距离检索框的位置
        setBottomH(){
            let top=this.$refs.searchBox?.getBoundingClientRect().top;
            if(top>0){
                return window.innerHeight-top;
            }
            return 0;
        },
        //
        /**点单界面横排数量按钮 */
        keyNumber(number){
            number=number+"";
            let orderNumber=this.orderNumber;
            if(orderNumber.indexOf('.')!=-1 && (number=='.' || number=='0.5')){
                return 
            }
            
            if(number>0 || number==="0" || number==='.'){
                if(/^\d*[.]\d{4}/.test(orderNumber)){//小数位长度已经到4位 
                    return;
                }
                this.orderNumberType=number;
            }

            if(number=='-1' && orderNumber.length>0){
                orderNumber= orderNumber.substring(0,orderNumber.length-1);
            }else{
                if(orderNumber=="" && number=='.'){
                    orderNumber =  "0.";
                }else{
                    //orderNumber =  orderNumber+number;
                    if(number=="0.5"){
                        orderNumber =Number(orderNumber).compute(number)+"";
                    }else{
                        orderNumber =  orderNumber+number;
                    }
                }
                

                if(!/^(([-]?([1-9]\d*)|\d?)([.]\d*)?$)/g.test(orderNumber)){
                    if(/^((([0-9]\d*)|\d?)([.]\d*)?$)/g.test(orderNumber)){
                        if(/^0+$/g.test(orderNumber)){
                            orderNumber="0";
                        }else{
                            orderNumber=orderNumber.replace(/^0*(?![.])/g,"");
                        }
                    }
                }
            }

            if(Number(orderNumber)<0){
                orderNumber="";
            }

            let index=orderNumber?.indexOf(".");
            if(index>=0){//保留小数位4位
               let str= orderNumber.substring(0,index+5);
                if(str!=orderNumber){
                    orderNumber=str;
                }
            }
            this.parent.orderNumber=orderNumber;
        },
        /**点击大类*/
        onFoodNav(item,index){
            if(item){
                this.mainCategoryIndex=index;
            }else{//所有
                this.mainCategoryIndex=0;
            }
            this.foodSubPageIndex=0;
            this.$nextTick(()=>{
                this.foodSubPageIndex=1;
            })
            this.onFoodSubNav(null,0)
        },
        /**点击小类*/
        onFoodSubNav(item,index){
            this.subCategoryIndex=index;
            this.varietySelect="";
            this.oldVarietySelect="";
            this.menuTxt="";
        },
        //扫描枪 建索商品
        barcode(){
            console.log("barcode")
            let menuTxt=(this.varietySelect||"").toLowerCase().trim();
            if(menuTxt){
                //是否通过条码秤规则 识别菜
                let isBarcodeScale=false;
                let item=null;
                if(this.$global.barcodeScaleInfo?.isBarcodeScale){//启用条码秤菜品识别功能
                    const foodCodeStartIndex=(Number(this.$global.barcodeScaleInfo.foodCodeStartIndex)||1)-1;
                    const foodCodeLength=Number(this.$global.barcodeScaleInfo.foodCodeLength);
                    const foodNumberStartIndex=(Number(this.$global.barcodeScaleInfo.foodNumberStartIndex)||1)-1;
                    const foodNumberLength=this.$global.barcodeScaleInfo.foodNumberLength;
                    if(Math.max(foodCodeStartIndex+foodCodeLength,foodNumberStartIndex+foodNumberLength)<=menuTxt.length){
                        const foodDecimal=Number(this.$global.barcodeScaleInfo?.foodDecimal)||0;
                        let number=Number((Number(menuTxt.substring(foodNumberStartIndex,foodNumberStartIndex+foodNumberLength))||0)/Math.pow(10,foodDecimal));
                        if(number>0){
                            menuTxt=menuTxt.substring(foodCodeStartIndex,foodCodeStartIndex+foodCodeLength);
                           
                            this.allFoods?.some(it=>{
                                if((it.Food_Code||"").toLowerCase()==menuTxt){
                                    item=Object.assign({},it,{Eat_Number:number});
                                    return true;
                                }else{
                                    return it.MultipleSizeFoods?.some(sizeItem=>{
                                        if((sizeItem.Food_Code||"").toLowerCase()==menuTxt){
                                            item=Object.assign({},sizeItem,{Eat_Number:number});
                                            return true;
                                        }
                                        return false;
                                    })
                                }
                            });
                            isBarcodeScale=true;
                        }
                    }
                }
                if(!isBarcodeScale){
                    this.allFoods?.some(it=>{
                        if((it.Food_BarCode||"").toLowerCase()==menuTxt){
                            item=Object.assign({},it);
                            return true;
                        }else{
                            return it.MultipleSizeFoods?.some(sizeItem=>{
                                if((sizeItem.Food_BarCode||"").toLowerCase()==menuTxt){
                                    item=Object.assign({},sizeItem);
                                    return true;
                                }
                                return false;
                            })
                        }
                    });
                }
                if(item){
                    if(item.Is_MultipleSize){
                        item.Is_MultipleSize=false;
                    }
                    this.parent.onPlaceFoods(item);
                    //扫码的 清除记录
                    this.oldVarietySelect=""
                }
            }
        },
        /**控制菜品搜索框 上下左右光标 */
        keyCursor(e){
            if(e.keyCode=='37' || e.keyCode=='38' || e.keyCode=='39' || e.keyCode=='40' || e.keyCode=='13'){
                e.preventDefault();
                if(this.foodsPages && this.foodsPages.length>0){
                    let index=this.foodsPages.findIndex(item=>item.Food_ID==this.choicePosFoods);
                    
                    if(e.keyCode=='37'){//左边
                        index--;
                    }else if(e.keyCode=='38'){//上
                        index=index-this.arg.col
                    }else if(e.keyCode=='39'){//右边
                        index++;
                    }else if(e.keyCode=='40'){//下
                        index=index+this.arg.col;
                    }else if(e.keyCode=='13'){
                        if(this.foodsPages.length>0){
                            if(index>=0 && this.getFoodNumber(this.foodsPages[index])>0 && this.choicePosFoods==this.foodsPages[index].Food_ID){
                                this.$confirm("【"+this.foodsPages[index].Food_Name+"】已点，是否继续添加一份?", "提示", {
                                    confirmButtonText: "确定",
                                    cancelButtonText:"取消",
                                    callback: (name) => {
                                        if(name=='confirm'){
                                            this.parent.onPlaceFoods(this.foodsPages[index]);
                                        }
                                    },
                                });
                            }else{
                                this.parent.onPlaceFoods(this.foodsPages[index]);
                            }
                        }else{
                            this.$message.warning('未找到菜品');
                            return
                        }
                        return;
                    }
                    if(index<0) index=0;
                    if(index>=0 && index<this.foodsPages.length){
                        this.choicePosFoods=this.foodsPages[index].Food_ID;
                    }
                }
            }
        },
        /**菜品点菜数量 标识 */
        getFoodNumber(item){
            let num=0;
            if(this.foodNumberKey[item.Food_ID]>0){
                num=this.foodNumberKey[item.Food_ID];
            }
            if(item.MultipleSizeFoods?.some(it=>this.foodNumberKey[it.Food_ID]>0)){
                item.MultipleSizeFoods.forEach(it=>{
                    if(this.foodNumberKey[it.Food_ID]>0){
                        num+=this.foodNumberKey[it.Food_ID];
                    }
                })
                num=Number(num.toFixed(4));
            }
            return num;
        },
        //刷新菜品数据
        RefreshData(){
            const loading = this.$loading({
                text: "信息加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)",
            });
            this.$cacheData.RefreshSoldInfo().then(()=>{
                loading.close();
            }).catch((e)=>{ 
                loading.close();
                this.$message.error("刷新失败:"+e.message);
            });
        },
        /**跳转到菜单点菜 */
        menuOrder(){
            if(this.DeskLocked && this.lockEqId!=  config.UUID){
                this.$alert("本桌号已锁定，请先解锁后进入菜单点餐！")
            }else{
                this.$router.push({
                    name:'ipdUserOrderMode',
                    params:{
                        Desk_AutoID:this.posDesks.Desk_AutoID,
                        Eat_AutoID:this.posDesks.Eat_AutoID,
                        Eat_RoomID:this.Eat_RoomID,//餐厅id
                    }
                });
            }
        },
        /**显示遗漏菜 */
        showMissedFood(foods){
            this.missedFoodList=foods;
            this.isShowMissed=true;
            this.onFoodNav();
        },
        /**下单后 要关闭遗漏 */
        closeMissedFood(orderFood){
            if(this.missedFoodList?.length>0){
                //下单后的菜 包含有遗漏的菜 不在显示遗漏
                if(orderFood?.some(it=>it.Eat_Number>0 && this.missedFoodList.some(food=>food.EAT_XFBMID==it.EAT_XFBMID))){
                    this.missedFoodList=[];
                    this.isShowMissed=false;
                }
            }
        }
    }
}
</script>

<style lang="scss">
    .missedBnt.floatingMenu.defaultStyle{
        padding: 0;
        width: auto ;
        top: 26px;
        left: 45%;
        height: 37px;
        font-size: 14px;
        background: #fff;
        overflow: hidden;
        box-shadow:none;
        border:1px solid #487BB2;
        border-radius: 4px;
        display: flex;
        align-items: center;
        box-shadow:2px 2px 5px 1px rgba(0,0,0,0.3);

        .icon-box{
            height:35px;
            display: inline-block;
            text-align: center;
            width: 35px;
            background-color:#487BB2;
            color: #fff;
            font-size: 16px;
            line-height: 35px;
        }

        span{
            padding: 0 5px;
            color: #000;
            font-weight: bold;
        }
    }
</style>